export default __webpack_public_path__ + "static/media/langchainHexagonIcon.9aceceb9.svg";